import React from "react";
import { Badge, Box, IconButton, InputBase, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Search, Tune } from "@mui/icons-material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useTranslation } from "react-i18next";

/**
 * Busca sutil no padrão da lista de clientes: texto + ícone de filtros avançados.
 */
export default function AwarenessClientSearchBar({
  value = "",
  onChange,
  onOpenAdvanced,
  activeFilterCount = 0,
}) {
  const theme = useTheme();
  const { t } = useTranslation("settings");
  const hasValue = String(value || "").trim().length > 0;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: { xs: "100%", sm: 260 },
        maxWidth: { xs: "100%", sm: 340 },
        flex: { xs: "1 1 100%", sm: "0 1 320px" },
        height: 36,
        border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
        borderRadius: 2,
        px: 1,
        bgcolor: alpha(theme.palette.background.paper, theme.palette.mode === "dark" ? 0.35 : 0.72),
      }}
    >
      <Search sx={{ mr: 0.75, color: "text.secondary", fontSize: 18, flexShrink: 0 }} />
      <InputBase
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={t("pipelinePage.searchPlaceholder")}
        inputProps={{ "aria-label": t("pipelinePage.searchAria") }}
        sx={{
          flex: 1,
          minWidth: 0,
          fontSize: "0.82rem",
          color: "text.primary",
          "& input": { py: 0, height: 22 },
        }}
      />
      {hasValue ? (
        <Tooltip title={t("pipelinePage.clearSearch")}>
          <IconButton
            size="small"
            aria-label={t("pipelinePage.clearSearch")}
            onClick={() => onChange?.("")}
            sx={{ color: "text.secondary" }}
          >
            <CloseRoundedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      ) : null}
      <Tooltip title={t("pipelinePage.advancedSearch")}>
        <IconButton
          size="small"
          onClick={onOpenAdvanced}
          aria-label={t("pipelinePage.advancedSearchAria")}
          sx={{ color: activeFilterCount > 0 ? "primary.main" : "text.secondary" }}
        >
          <Badge
            color="secondary"
            badgeContent={activeFilterCount > 0 ? activeFilterCount : null}
            overlap="circular"
          >
            <Tune sx={{ fontSize: 18 }} />
          </Badge>
        </IconButton>
      </Tooltip>
    </Box>
  );
}
